import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const AboutSection = () => {
  const textRef = useScrollAnimation();
  const imgRef = useScrollAnimation();

  return (
    <section id="about" className="py-24 md:py-36 bg-[#0a0a0a] overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-2 gap-16 md:gap-24 items-center">
          {/* Text — left */}
          <div ref={textRef} className="fade-in-left">
            <span className="text-gold text-xs tracking-[0.4em] uppercase font-body">Nuestra Historia</span>
            <div className="h-px w-12 bg-gold mt-3 mb-8" />
            <h2 className="font-heading text-4xl md:text-5xl text-[#ededed] leading-tight mb-6">
              Tradición y calidad<br />
              <span className="italic text-gold-dark">en cada plato</span>
            </h2>
            <p className="font-body text-[#a3a3a3] text-base leading-relaxed mb-6">
              Restaurante Neli es un espacio familiar ubicado en el corazón de Ansoáin, Navarra. Aquí, la tradición y la calidad se unen para ofrecer una experiencia gastronómica cercana y auténtica.
            </p>
            <p className="font-body text-[#a3a3a3] text-base leading-relaxed mb-10">
              Con un ambiente acogedor y un trato amable, somos el lugar ideal para disfrutar de comidas caseras, reuniones familiares o encuentros entre amigos, siempre con ingredientes frescos y platos preparados con dedicación.
            </p>

            {/* Mission statement */}
            <blockquote className="border-l-2 border-gold pl-6 py-2">
              <p className="font-accent italic text-xl text-[#ededed]">
                "Que comas bien, te sientas como en casa y quieras volver."
              </p>
            </blockquote>
          </div>

          {/* Images — right, asymmetric */}
          <div ref={imgRef} className="fade-in-right relative">
            <div className="relative">
              {/* Main image */}
              <img
                src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800&q=80"
                alt="Interior del restaurante"
                className="w-full h-[480px] object-cover"
              />
              {/* Overlay label */}
              <div className="absolute bottom-0 left-0 right-0 bg-[#0a0a0a]/80 px-6 py-4 border-t border-[#262626]">
                <p className="text-gold text-xs tracking-widest uppercase">Ctra. Ansoáin, 6 · 31013 Ansoáin, Navarra</p>
              </div>
              {/* Gold corner accent */}
              <div className="absolute top-4 right-4 w-12 h-12 border-t-2 border-r-2 border-gold" />
              <div className="absolute bottom-20 left-4 w-12 h-12 border-b-2 border-l-2 border-gold" />
            </div>

            {/* Small inset image */}
            <div className="absolute -bottom-8 -left-8 w-40 h-40 border-2 border-[#1c1c1c] overflow-hidden hidden md:block">
              <img
                src="https://images.unsplash.com/photo-1529042410759-befb1204b468?w=300&q=80"
                alt="Cocina casera"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
